import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0732b3ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mm" }
const _hoisted_2 = { class: "mm-account" }
const _hoisted_3 = { class: "mm-account__avatar" }
const _hoisted_4 = { class: "mm-account__meta" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-chevron-right mm-account__chevron",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_6 = {
  key: 1,
  class: "mm-account__guest"
}
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mm-item__icon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-plus" })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mm-item__icon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-house-circle-check" })
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mm-item__icon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-bell" })
], -1))
const _hoisted_11 = {
  key: 0,
  class: "mm-item__dot",
  "aria-hidden": "true"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mm-item__icon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-gift" })
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mm-item__icon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-heart" })
], -1))
const _hoisted_14 = {
  key: 0,
  class: "mm-group mm-group--nav"
}
const _hoisted_15 = { class: "mm-group__label" }
const _hoisted_16 = { class: "mm-group mm-group--utils" }
const _hoisted_17 = { class: "mm-item mm-item--static" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mm-item__icon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-globe" })
], -1))
const _hoisted_19 = ["href"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mm-item__icon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-phone" })
], -1))
const _hoisted_21 = { class: "mm-item__trail" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mm-item__icon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-arrow-right-from-bracket" })
], -1))

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import commons from '@/utils/Common'
import {
  CUSTOMER_POST_NEWS,
  FAVOURITE,
  HOME,
  LOGIN,
  LOGIN_DAILY_POINT,
  REGISTERS,
  ROOM_MANAGER,
} from '@/const/path'

interface Props {
  dataMenu?: any[]
  isLogin?: boolean
  userTagName?: string
  hasUnread?: boolean
  langLabelShort?: string
  hotline?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuMobile',
  props: {
    dataMenu: { default: () => [] },
    isLogin: { type: Boolean, default: false },
    userTagName: { default: '' },
    hasUnread: { type: Boolean, default: false },
    langLabelShort: { default: 'VN' },
    hotline: { default: '' }
  },
  emits: ["close", "open-notifications", "open-account", "toggle-lang", "change-lang", "logged-out"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const { t, te, locale } = useI18n()
const router = useRouter()
const active = router.currentRoute.value.path

const avatarInitial = computed(() => {
  const name = (props.userTagName || 'U').trim()
  return name.charAt(0).toUpperCase() || 'U'
})

const hotlineDisplay = computed(() => String(props.hotline || '').trim())
const hotlineHref = computed(() => {
  const digits = hotlineDisplay.value.replace(/[^\d+]/g, '')
  return digits ? `tel:${digits}` : ''
})

const isLangVn = computed(() => {
  const code = locale.value || (props.langLabelShort === 'EN' ? 'us' : 'vn')
  return code !== 'us'
})

const menuLabel = (linkLabel?: string) => {
  const label = String(linkLabel || '').trim()
  if (!label) return ''
  return te(label) ? t(label) : label
}

const closeThen = (fn: () => void) => {
  emit('close')
  fn()
}

const go = (path: string) => {
  if (!path) return
  closeThen(() => {
    router.push(path).catch(() => undefined)
  })
}

const requireLoginThen = (path: string) => {
  if (!props.isLogin) {
    go(LOGIN)
    return
  }
  go(path)
}

const goLogin = () => go(LOGIN)
const goRegister = () => go(REGISTERS)
const goPostNews = () => requireLoginThen(CUSTOMER_POST_NEWS)
const goRooms = () => requireLoginThen(ROOM_MANAGER)
const goDailyPoints = () => go(LOGIN_DAILY_POINT)
const goFavourite = () => go(FAVOURITE)

const onOpenAccount = () => {
  emit('close')
  emit('open-account')
}

const onOpenNotifications = () => {
  if (!props.isLogin) {
    go(LOGIN)
    return
  }
  emit('close')
  emit('open-notifications')
}

const onLangSwitch = (checked: boolean) => {
  emit('change-lang', checked ? 'vn' : 'us')
}

const logOut = () => {
  emit('close')
  commons.logOut()
  emit('logged-out')
  router.push({ path: HOME }).catch(() => undefined)
}

return (_ctx: any,_cache: any) => {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_switch = _resolveComponent("a-switch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      (_ctx.isLogin)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "mm-account__card",
            onClick: onOpenAccount
          }, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(avatarInitial.value), 1),
            _createElementVNode("span", _hoisted_4, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.userTagName || _ctx.$t('header.account')), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('header.viewAccount')), 1)
            ]),
            _hoisted_5
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("button", {
              type: "button",
              class: "mm-btn mm-btn--primary",
              onClick: goLogin
            }, _toDisplayString(_ctx.$t('text.login')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "mm-btn mm-btn--ghost",
              onClick: goRegister
            }, _toDisplayString(_ctx.$t('text.register')), 1)
          ]))
    ]),
    _createElementVNode("section", {
      class: "mm-group mm-group--actions",
      "aria-label": _ctx.$t('header.quickActions')
    }, [
      _createElementVNode("button", {
        type: "button",
        class: "mm-item mm-item--cta",
        onClick: goPostNews
      }, [
        _hoisted_8,
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('header.create')), 1)
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "mm-item",
        onClick: goRooms
      }, [
        _hoisted_9,
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('header.manageRooms')), 1)
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "mm-item",
        onClick: onOpenNotifications
      }, [
        _hoisted_10,
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('header.notifications')), 1),
        (_ctx.hasUnread)
          ? (_openBlock(), _createElementBlock("span", _hoisted_11))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "mm-item",
        onClick: goDailyPoints
      }, [
        _hoisted_12,
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('loginGetPoint.title')), 1)
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "mm-item",
        onClick: goFavourite
      }, [
        _hoisted_13,
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('text.favourite')), 1)
      ])
    ], 8, _hoisted_7),
    (_ctx.dataMenu.length)
      ? (_openBlock(), _createElementBlock("section", _hoisted_14, [
          _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('header.browse')), 1),
          _createVNode(_component_a_menu, {
            mode: "inline",
            selectedKeys: [_unref(active)],
            class: "mobile-menu"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataMenu, (item) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: item.id || item.linkTo
                }, [
                  (item.children?.length)
                    ? (_openBlock(), _createBlock(_component_a_sub_menu, {
                        key: `sub-${item.id}`
                      }, {
                        title: _withCtx(() => [
                          _createElementVNode("span", null, [
                            (item.icon)
                              ? (_openBlock(), _createElementBlock("i", {
                                  key: 0,
                                  class: _normalizeClass(item.icon)
                                }, null, 2))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(menuLabel(item.linkLabel)), 1)
                          ])
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: child.id || child.linkTo
                            }, [
                              (child.children?.length)
                                ? (_openBlock(), _createBlock(_component_a_sub_menu, {
                                    key: `sub-${child.id}`
                                  }, {
                                    title: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(menuLabel(child.linkLabel)), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(child.children, (sub) => {
                                        return (_openBlock(), _createBlock(_component_a_menu_item, {
                                          key: sub.linkTo,
                                          onClick: ($event: any) => (go(sub.linkTo))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(menuLabel(sub.linkLabel)), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1024))
                                : (_openBlock(), _createBlock(_component_a_menu_item, {
                                    key: child.linkTo,
                                    onClick: ($event: any) => (go(child.linkTo))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(menuLabel(child.linkLabel)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                            ], 64))
                          }), 128))
                        ]),
                        _: 2
                      }, 1024))
                    : (_openBlock(), _createBlock(_component_a_menu_item, {
                        key: item.linkTo,
                        onClick: ($event: any) => (go(item.linkTo))
                      }, {
                        default: _withCtx(() => [
                          (item.icon)
                            ? (_openBlock(), _createElementBlock("i", {
                                key: 0,
                                class: _normalizeClass(item.icon)
                              }, null, 2))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(menuLabel(item.linkLabel)), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                ], 64))
              }), 128))
            ]),
            _: 1
          }, 8, ["selectedKeys"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('header.language')), 1),
        _createVNode(_component_a_switch, {
          class: "mm-lang-switch",
          size: "small",
          checked: isLangVn.value,
          "checked-children": "VN",
          "un-checked-children": "EN",
          onChange: onLangSwitch
        }, null, 8, ["checked"])
      ]),
      (hotlineHref.value)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            class: "mm-item",
            href: hotlineHref.value
          }, [
            _hoisted_20,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('text.contactHotline')), 1),
            _createElementVNode("span", _hoisted_21, _toDisplayString(hotlineDisplay.value), 1)
          ], 8, _hoisted_19))
        : _createCommentVNode("", true),
      (_ctx.isLogin)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            type: "button",
            class: "mm-item mm-item--danger",
            onClick: logOut
          }, [
            _hoisted_22,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('text.logOut')), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})